import React from 'react';

import '../global.css';

export default () => (
	<div>
		Redirecting to Bitly, from Dasher...
	</div>
);